import Vue from 'vue'
import Vuex from 'vuex'
import Constant from './assets/Constants'
import VueSession from 'vue-session'
Vue.use(VueSession)
Vue.use(Vuex)
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(axios)
const state = {
  Loading:{
    MainLoading2:false,
    Dashboard:false,
    MainLoading:true,
    Authentication_Add:false,
    Fleet_GetAccessByGroup:false,
    UserGroup_GetAll:false,
    Fleet_Add:false,
    Device_AssignToFleet:false,
    Device_GetLikeIMEI:false,
    DeviceType_GetAll:false,
    Fleet_GetLikeName:false,
    Users_Login:false,
    FleetByUser:false,
    Driver_Update:false,
    Device_MoveToFleet:false,
    Fleet_Update:false,
    Vehicle_Update:false,
    Messages_AddAuto:false,
    Report_Vehicle_Stop:false,
    Report_Vehicle_Park:false,
    Device_GetByVehicle:false,
    Report_X1:false,
    Report_X1ByFleet:false,
    GPSData:false,
    MapObject_GetMarkerByFleet:false,
    Trajectory_GetByUserID:false,
    LineStations_GetByUserID:false,
    BusLine_GetByUserID:false,
    Personnel_GetByID:false,
    Driver_GetByFleetID:false,
    Vehicle_GetByFleetID:false,
    VehicleType_GetAll:false,
    MapPoints_GetByID:false,
    MapObject_GetByFleetAndType:false,
    MapObject_GetPointsMarker:false,
    Device_GetByFleetID:false,
    Device_GetByFleetID_SortMaxEN:false,
    Device_GetAllByUserID:false,
    Fleet_GetAll:false,
    ConnectionState_GetToday:false,
    Device_GetInfoLikeIMEI:false,
    Alarm_GetAdvance:false,
    Alarm_GetAdvanceReport:false,
    UpdateDevice:false,
    User_AddFull:false,
    Authentication_Delete:false,
    AlarmDefinitions_GetAll:false,
    DayDefine_GetAll:false,
    DayDefine_Insert:false,
    DayDefine_Update:false,
    DayDefine_DeletByID:false,
    SmartTariff_GetAll:false,
    SmartTariff_GetByFleetID:false,
    SmartTariff_InsertAndUpdate:false,
    SmartTariff_Delete:false,
    Device_UpdateMaxEN:false,
    SmartTariff_GetToDay:false,
    Calendar_InsertAndUpdate:false,
    Calendar_GetByDate:false,
    TrajectoryHistory_GetByUserAndTime:false,
    TrajectoryHistory_GetByFleetAndTime:false,
    TrajectoryHistory_GetByDeviceIDAndTime:false,
    Trajectory_FleetMustChange:false,
    Trajectory_FleetMustChangeALL:false,
    Commands_Add:false,
    FleetHistory_GetByDate:false,
    FleetHistory_GetByVehicle:false,
    FleetHistory_GetByFleet:false,
    FleetHistory_GetByDriver:false,
    DeviceDistanceHistory_GetALLDayByDevice:false,
    DeviceDistanceHistory_GetByUserIDAndDate:false,
    DeviceDistanceHistory_GetByFleetAndDate:false,
    StationTraffic_GetByStasionCodeAndTime:false,
    StationTraffic_GetByDeviceAndTime:false,
    Station_GetByFleet2:false,
    Fleet_GetComplateData:false,
    Company_GetByUserID:false,
    Company_Insert:false,
    Company_UpdateByID:false,
    ViolationList_GetAll:false,
    ViolationList_GetAll:false,
    Violation_GetAdvance:false,
    Violation_GetTop10ByUserID:false,
    Violation_Insert:false,
    BusLines_GetByCrop:false,
    Station_GetByCrop:false,
    Device_GetByCrop:false,
    ViolationList_Delete:false,
    SystemInfo_Get:false,
    DeviceSipad_GetDetaileByUser:false,
    DeviceSipad_GetByFleet:false,
    DeviceSipad_GetByDevice:false,
    User_ChangePass:false,
    User_Update:false,
    Rules_GetAll:false,
    Rules_Get:false,
    RulesPermission_Update:false,
    RulesApiPermissions_GetByRole:false,
    RulesApiPermissions_InsertOrUpdate:false,
    User_Delete:false,
    ViolationList_Update:false,
    Violation_Update:false,
    User_GetAllDeviceStatus:false,
    User_GetAllDeviceStatus2:false,
    SipadErrorLog_GetByTurn:false,
    DeviceSipad_GetStatus:false,
    UserGroup_DeleteByID:false,
    User_ChangeRole:false,
    Device_AdvancedSearch:false,
    Vehicle_AdvancedSearch:false,
    Driver_AdvancedSearch:false,
    User_ActiveList:false,
    Fleet_GetAllActiveInfo:false,
    Rules_Insert:false,
    Widget1_Get:false,
    Widget2_Get:false,
    Widget3_Get:false,
    Widget4_Get:false,
    Widget5_Get:false,
    TransactionFilter:false,
  },
  InlineLoading:{
    UserGroup_GetAll:false,
    Fleet_GetAccessByGroup:false,
    Device_GetLikeIMEI:false,
    DeviceType_GetAll:false,
    Fleet_GetLikeName:false,
    FleetByUser:false,
    Driver_Update:false,
    Device_MoveToFleet:false,
    Fleet_Update:false,
    Vehicle_Update:false,
    Messages_AddAuto:false,
    Report_Vehicle_Stop:false,
    Report_Vehicle_Park:false,
    Device_GetByVehicle:false,
    Report_X1:false,
    Report_X1ByFleet:false,
    GPSData:false,
    MapObject_GetMarkerByFleet:false,
    Trajectory_GetByUserID:false,
    LineStations_GetByUserID:false,
    BusLine_GetByUserID:false,
    Personnel_GetByID:false,
    Driver_GetByFleetID:false,
    Vehicle_GetByFleetID:false,
    VehicleType_GetAll:false,
    MapPoints_GetByID:false,
    MapObject_GetByFleetAndType:false,
    MapObject_GetPointsMarker:false,
    Device_GetByFleetID:false,
    Device_GetByFleetID_SortMaxEN:false,
    Device_GetAllByUserID:false,
    Fleet_GetAll:false,
    Device_GetInfoLikeIMEI:false,
    Alarm_GetAdvance:false,
    Alarm_GetAdvanceReport:false,
    UpdateDevice:false,
    User_GetByGroupID:false,
    User_AddFull:false,
    Authentication_Delete:false,
    AlarmDefinitions_GetAll:false,
    DayDefine_GetAll:false,
    DayDefine_Insert:false,
    DayDefine_Update:false,
    DayDefine_DeletByID:false,
    SmartTariff_GetAll:false,
    SmartTariff_GetByFleetID:false,
    SmartTariff_InsertAndUpdate:false,
    SmartTariff_Delete:false,
    Device_UpdateMaxEN:false,
    SmartTariff_GetToDay:false,
    Calendar_InsertAndUpdate:false,
    Calendar_GetByDate:false,
    TrajectoryHistory_GetByUserAndTime:false,
    TrajectoryHistory_GetByFleetAndTime:false,
    TrajectoryHistory_GetByDeviceIDAndTime:false,
    Trajectory_FleetMustChange:false,
    Trajectory_FleetMustChangeALL:false,
    Commands_Add:false,
    FleetHistory_GetByDate:false,
    FleetHistory_GetByVehicle:false,
    FleetHistory_GetByFleet:false,
    FleetHistory_GetByDriver:false,
    DeviceDistanceHistory_GetALLDayByDevice:false,
    DeviceDistanceHistory_GetByUserIDAndDate:false,
    DeviceDistanceHistory_GetByFleetAndDate:false,
    StationTraffic_GetByStasionCodeAndTime:false,
    StationTraffic_GetByDeviceAndTime:false,
    Station_GetByFleet2:false,
    Fleet_GetComplateData:false,
    Company_GetByUserID:false,
    Company_Insert:false,
    Company_UpdateByID:false,
    ViolationList_GetAll:false,
    ViolationList_GetAll:false,
    Violation_GetAdvance:false,
    Violation_GetTop10ByUserID:false,
    Violation_Insert:false,
    BusLines_GetByCrop:false,
    Station_GetByCrop:false,
    Device_GetByCrop:false,
    ViolationList_Delete:false,
    SystemInfo_Get:false,
    DeviceSipad_GetDetaileByUser:false,
    DeviceSipad_GetByFleet:false,
    DeviceSipad_GetByDevice:false,
    User_ChangePass:false,
    User_Update:false,
    Rules_GetAll:false,
    Rules_Get:false,
    RulesPermission_Update:false,
    RulesApiPermissions_GetByRole:false,
    RulesApiPermissions_InsertOrUpdate:false,
    User_Delete:false,
    ViolationList_Update:false,
    Violation_Update:false,
    User_GetAllDeviceStatus:false,
    User_GetAllDeviceStatus2:false,
    SipadErrorLog_GetByTurn:false,
    DeviceSipad_GetStatus:false,
    UserGroup_DeleteByID:false,
    User_ChangeRole:false,
    Device_AdvancedSearch:false,
    Vehicle_AdvancedSearch:false,
    Driver_AdvancedSearch:false,
    User_ActiveList:false,
    Fleet_GetAllActiveInfo:false,
    Rules_Insert:false,
    Widget1_Get:false,
    Widget2_Get:false,
    Widget3_Get:false,
    Widget4_Get:false,
    Widget5_Get:false,
    TransactionFilter:false,
  },
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  Toasts:[],
  AllFleets:{
    RequestResponse:[],
  },
  Device_GetLikeIMEI:{
    RequestResponse:[],
  },
  DeviceType_GetAll:{
    RequestResponse:[],
  },
  Fleets:{
    RequestResponse:[],
  },
  LikeFleets:{
    RequestResponse:[],
  },
  FleetsOptions:{
    RequestResponse:[],
  },
  Groups:{
    RequestResponse:[],
  },
  Devices:{
    RequestResponse:[],
  },
  Markers:{
    RequestResponse:[],
  },
  Polygone:{
    RequestResponse:[],
  },
  Polyline:{
    RequestResponse:[],
  },
  VehicleTypes:{
    RequestResponse:[],
  },
  Vehicles:{
    RequestResponse:[],
  },
  Drivers:{
    RequestResponse:[],
  },
  Personal:{
    RequestResponse:[],
  },
  LineStations:{
    RequestResponse:[],
  },
  Polygones:{
    RequestResponse:[],
  },
  FleetMarkers:{
    RequestResponse:[],
  },
  GPS_DATA:{
    RequestResponse:[],
  },
  FleetReports:{
    RequestResponse:[],
  },
  VehicleReports:{
    RequestResponse:[],
  },
  ParkData:{
    RequestResponse:[],
  },
  Vehicle_Update:{
    RequestResponse:[],
  },
  StopData:{
    RequestResponse:[],
  },
  ResponseMessages_AddAuto:{
    RequestResponse:[],
  },
  increment:0,
  test:{
    RequestResponse:[],
  },
  ConnectionState_GetToday:{
    RequestResponse:[],
  },
  ConnectionState_GetMonth:{
    RequestResponse:[],
  },
  User_GetAllDeviceStatus:{
    RequestResponse:[],
  },
  User_GetAllDeviceStatus2:{
    RequestResponse:[],
  },
  DeviceDistanceHistory_GetByUserGroupByDay:{
    RequestResponse:[],
  },
  ResponseAuthentication_Add:{
    RequestResponse:[],
  },
  MapObject_GetByFleetAndType:{
    RequestResponse:[],
  },
  MapPoints_GetByID:{
    RequestResponse:[],
  },
  BusLines_GetInfo:{
    RequestResponse:[],
  },
  Users_Login:{
    RequestResponse:[],
  },
  Users:{
    RequestResponse:[],
  },
  AlarmDefinitions:{
    RequestResponse:[],
  },
  DayDefine_GetAll:{
    RequestResponse:[],
  },
  SmartTariff_GetAll:{
    RequestResponse:[],
  },
  SmartTariff_GetToDay:{
    RequestResponse:[],
  },
  Calendar_GetByDate:{
    RequestResponse:[],
  },
  TrajectoryHistory_GetByUserAndTime:{
    RequestResponse:[],
  },
  TrajectoryHistory_GetByFleetAndTime:{
    RequestResponse:[],
  },
  TrajectoryHistory_GetByDeviceIDAndTime:{
    RequestResponse:[],
  },
  Trajectory_FleetMustChange:{
    RequestResponse:[],
  },
  FleetHistory_GetByDate:{
    RequestResponse:[],
  },
  DeviceDistanceHistory_GetALLDayByDevice:{
    RequestResponse:[],
  },
  DeviceDistanceHistory_GetByUserIDAndDate:{
    RequestResponse:[],
    Data_1:[],
  },
  DeviceDistanceHistory_GetByFleetAndDate:{
    RequestResponse:[],
    Data_1:[],
  },
  StationTraffic_GetByStasionCodeAndTime:{
    RequestResponse:[],
  },
  StationTraffic_GetByDeviceAndTime:{
    RequestResponse:[],
  },
  Station_GetByFleet2:{
    RequestResponse:[],
  },
  Fleet_GetComplateData:{
    RequestResponse:[],
  },
  Company_GetByUserID:{
    RequestResponse:[],
  },
  ViolationList_GetAll:{
    RequestResponse:[],
  },
  Violation_GetAdvance:{
    RequestResponse:[],
  },
  Violation_GetTop10ByUserID:{
    RequestResponse:[],
  },
  BusLines_GetByCrop:{
    RequestResponse:[],
  },
  Station_GetByCrop:{
    RequestResponse:[],
  },
  Device_GetByCrop:{
    RequestResponse:[],
  },
  SystemInfo_Get:{
    RequestResponse:[],
  },
  DeviceSipad_Data:{
    RequestResponse:[],
  },
  Rules_GetAll:{
    RequestResponse:[],
  },
  Rules_Get:{
    RequestResponse:[],
  },
  RulesApiPermissions_GetByRole:{
    RequestResponse:[],
  },
  DeviceSipad_GetStatus:{
    RequestResponse:[],
  },
  User_ActiveList:{
    RequestResponse:[],
  },
  Fleet_GetAllActiveInfo:{
    Data_1:{},
    RequestResponse:[],
  },
  Rules_Insert:{
    Data_1:{},
    RequestResponse:[],
  },
  Trajectory_GetByUserID:{
    RequestResponse:[],
    Data_1:{},
  },
  
  //res
  Device_MoveToFleet:{
    RequestResponse:[],
  },
  Device_AssignToFleet:{
    RequestResponse:[],
  },
  AddFleet:{
    RequestResponse:[],
  },
  UpdateFleet:{
    RequestResponse:[],
  },
  Alarm_GetAdvance:{
    RequestResponse:[],
    Data_1:[],
  },
  Alarm_GetAdvanceReport:{
    Data_1:[]
  },
  ResponseUpdateDevice:{
    RequestResponse:[],
  },
  Authentication_Add:{
    RequestResponse:[],
  },
  ResponseUser_AddFull:{
    RequestResponse:[],
  },
  ResponseFleet_Update:{},
  ResponseFleet_Add:{
    RequestResponse:[],
  },
  ResponseAuthentication_Delete:{
    RequestResponse:[],
  },
  DayDefine_Insert:{
    RequestResponse:[],
  },
  DayDefine_DeletByID:{
    RequestResponse:[],
  },
  SmartTariff_InsertAndUpdate:{
    RequestResponse:[],
  },
  SmartTariff_Delete:{
    RequestResponse:[],
  },
  Device_UpdateMaxEN:{
    RequestResponse:[],
  },
  DayDefine_Update:{
    RequestResponse:[],
  },
  Calendar_InsertAndUpdate:{
    RequestResponse:[],
  },
  Commands_Add:{
    RequestResponse:[],
  },
  Company_Insert:{
    RequestResponse:[],
  },
  Company_UpdateByID:{
    RequestResponse:[],
  },
  ViolationList_Insert:{
    RequestResponse:[],
  },
  Violation_Insert:{
    RequestResponse:[],
  },
  Violation_Delete:{
    RequestResponse:[],
  },
  ViolationList_Delete:{
    RequestResponse:[],
  },
  User_ChangePass:{
    RequestResponse:[],
  },
  User_Update:{
    RequestResponse:[],
  },
  RulesPermission_Update:{
    RequestResponse:[],
  },
  User_Delete:{
    RequestResponse:[],
  },
  UserGroup_DeleteByID:{
    RequestResponse:[],
  },
  RulesApiPermissions_InsertOrUpdate:{
    RequestResponse:[],
  },
  ViolationList_Update:{
    RequestResponse:[],
  },
  Violation_Update:{},
  SipadErrorLog_GetByTurn:{
    LIST1:[],
    LIST2:[],
    LIST3:[],
    LIST4:[],
  },
  User_ChangeRole:{
    RequestResponse:[],
  },
  BusLine_GetByUserID:{
    RequestResponse:[],
  },
  LineStations_GetByUserID:{
    RequestResponse:[],
  },
  Trajectory_FleetMustChangeALL:{
    RequestResponse:[],
  },
  Widget1_Get:{
    RequestResponse:[],
    Data_1:[],
    Data_2:[],
  },
  Widget2_Get:{
    RequestResponse:[],
    Data_1:[],
    Data_2:[],
  },
  Widget3_Get:{
    RequestResponse:[],
    Data_1:[],
    Data_2:[],
  },
  Widget4_Get:{
    RequestResponse:[],
    Data_1:[],
    Data_2:[],
  },
  Widget5_Get:{
    RequestResponse:[],
    Data_1:[],
    Data_2:[],
  },
  TransactionFilter:{},
}

const mutations = {
  increment(state){
    state.increment++;
  },
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  ShowToast(state,tos){
    var toast={Message:tos.message,MessageType:tos.type};
      var delayInMilliseconds = 3000; //3 second
              state.Toasts.push(toast);
              setTimeout(function() {
                state.Toasts.splice(toast,1);


              }, delayInMilliseconds);
  },
  Session(state,dat){
    state.InlineLoading.Fleet_GetLikeName=true;
    store.commit('Get',{
      url:Constant.Session,
      loading:'Fleet_GetLikeName',
      response:'LikeFleets'
    });
  },
  Fleet_GetLikeName(state,dat){
    state.InlineLoading.Fleet_GetLikeName=true;
    store.commit('Get',{
      url:Constant.Fleet_GetLikeName
      .replace('{Key}',dat.Key),
      loading:'Fleet_GetLikeName',
      response:'LikeFleets'
    });
  },
  Fleet_GetAccessByGroup(state,dat){
    state.InlineLoading.Fleet_GetAccessByGroup=true;
    store.commit('Get',{
      url:Constant.Fleet_GetAccessByGroup
      .replace('{GroupID}',dat.GroupID),
      loading:'Fleet_GetAccessByGroup',
      response:'Fleets'
    });
  },
  Device_GetLikeIMEI(state,dat){
    state.Loading.Device_GetLikeIMEI=true;
    store.commit('Get',{
      url:Constant.Device_GetLikeIMEI
      .replace('{Key}',dat.Key)
      .replace('{Type}',dat.Type)
      .replace('{Assign}',dat.Assign),
      loading:'Device_GetLikeIMEI',
      response:'Device_GetLikeIMEI'
    });
  },
  Device_GetInfoLikeIMEI(state,dat){
    state.InlineLoading.Device_GetInfoLikeIMEI=true;
    store.commit('Get',{
      url:Constant.Device_GetInfoLikeIMEI
      .replace('{Key}',dat.Key),
      loading:'Device_GetInfoLikeIMEI',
      response:'Devices'
    });
  },
  DeviceType_GetAll(state){
    state.Loading.DeviceType_GetAll=true;
    store.commit('Get',{
      url:Constant.DeviceType_GetAll,
      loading:'DeviceType_GetAll',
      response:'DeviceType_GetAll'
    });
  }, 
  UserGroup_GetAll(state){
    state.InlineLoading.UserGroup_GetAll=true;
    store.commit('Get',{
      url:Constant.UserGroup_GetAll,
      loading:'UserGroup_GetAll',
      response:'Groups'
    });
  },
  FleetByUser(state){
    state.Loading.FleetByUser=true;
    store.commit('Get',{
      url:Constant.FleetByUser,
      loading:'FleetByUser',
      response:'Fleets'
    });
  },
  Fleet_GetAll(state){
    state.Loading.Fleet_GetAll=true;
    store.commit('Get',{
      url:Constant.Fleet_GetAll,
      loading:'Fleet_GetAll',
      response:'AllFleets'
    });
  },
  Device_GetAllByUserID(state){
    state.InlineLoading.Device_GetAllByUserID=true;
    store.commit('Get',{
      url:Constant.Device_GetAllByUserID
      .replace('{UserID}',1),
      loading:'Device_GetAllByUserID',
      response:'Devices'
    });
  },
  Device_GetByFleetID(state,dat){
    state.InlineLoading.Device_GetByFleetID=true;
    store.commit('Get',{
      url:Constant.DeviceByFleet.replace('{FleetID}',dat.FleetID),
      loading:'Device_GetByFleetID',
      response:'Devices'
    });
  },
  Device_GetByFleetID_SortMaxEN(state,dat){
    state.InlineLoading.Device_GetByFleetID_SortMaxEN=true;
    store.commit('Get',{
      url:Constant.DeviceByFleet.replace('{FleetID}',dat.FleetID),
      loading:'Device_GetByFleetID_SortMaxEN',
      response:'Devices'
    });
  },
  MapObject_GetPointsMarker(state,dat){
    state.InlineLoading.MapObject_GetPointsMarker=true;
    store.commit('Get',{
      url:Constant.MapObject_GetPointsMarker
      .replace('{FleetID}',dat.FleetID),
      loading:'MapObject_GetPointsMarker',
      response:'Markers'
    });
  },
  MapObject_GetByFleetAndType(state,dat){
    state.InlineLoading.MapObject_GetByFleetAndType=true; 
    store.commit('Get',{
      url:Constant.MapObject_GetByFleetAndType
      .replace('{FleetID}',dat.FleetID)
      .replace('{Type}',dat.Type),
      loading:'MapObject_GetByFleetAndType',
      response:'MapObject_GetByFleetAndType'
    });
  },
  MapPoints_GetByID(state,dat){
    state.Loading.MapPoints_GetByID=true;
    store.commit('Get',{
      url:Constant.MapPoints_GetByID
      .replace('{ObjectID}',dat.ObjectID),
      loading:'MapPoints_GetByID',
      response:'MapPoints_GetByID'
    });
  },
  VehicleType_GetAll(state,dat){
    state.Loading.VehicleType_GetAll=true;
    store.commit('Get',{
      url:Constant.VehicleType_GetAll,
      loading:'VehicleType_GetAll',
      response:'VehicleTypes'
    });
  },
  Vehicle_GetByFleetID(state,dat){
    state.Loading.Vehicle_GetByFleetID=true;
    store.commit('Get',{
      url:Constant.Vehicle_GetByFleetID.replace('{FleetID}',dat.FleetID),
      loading:'Vehicle_GetByFleetID',
      response:'Vehicles'
    });
  },
  Driver_GetByFleetID(state,dat){
    state.Loading.Driver_GetByFleetID=true;
    store.commit('Get',{
      url:Constant.Driver_GetByFleetID.replace('{FleetID}',dat.FleetID),
      loading:'Driver_GetByFleetID',
      response:'Drivers'
    });
  },
  Personnel_GetByID(state,dat){
    state.Loading.Personnel_GetByID=true;
    store.commit('Get',{
      url:Constant.Personnel_GetByID
      .replace('{PersonelID}',dat.PersonalID),
      loading:'Personnel_GetByID',
      response:'Personal'
    });
  },
  Alarm_GetAdvance(state,dat){
    state.InlineLoading.Alarm_GetAdvance=true;
    store.commit('Get',{
      url:Constant.Alarm_GetAdvance
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID)
      .replace('{PageNumber}',dat.PageNumber)
      .replace('{RowsOfPage}',dat.RowsOfPage)
      .replace('{AlarmID}',dat.AlarmID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'Alarm_GetAdvance',
      response:'Alarm_GetAdvance'
    });
   
  }, 
  Alarm_GetAdvanceReport(state,dat){
    state.InlineLoading.Alarm_GetAdvanceReport=true;
    store.commit('Get',{
      url:Constant.Alarm_GetAdvanceReport
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID)
      .replace('{PageNumber}',dat.PageNumber)
      .replace('{RowsOfPage}',dat.RowsOfPage)
      .replace('{AlarmID}',dat.AlarmID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'Alarm_GetAdvanceReport',
      response:'Alarm_GetAdvanceReport'
    });
   
  }, 
  BusLine_GetByUserID(state,dat){
    state.InlineLoading.BusLine_GetByUserID=true;
    store.commit('Get',{
      url:Constant.BusLine_GetByUserID
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID)
      .replace('{PageNumber}',dat.PageNumber)
      .replace('{RowsOfPage}',dat.RowsOfPage)
      .replace('{AlarmID}',dat.AlarmID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'Alarm_GetAdvanceReport',
      response:'BusLine_GetByUserID'
    });
    // state.LineStations=[];
    // axios
    //     .get(Constant.BusLine_GetByUserID.replace('{UserID}',dat.UserID)/*, { withCredentials: true }*/)
    //     .then(response => {
    //         var data=response.data;
    //         if(data.Status){
    //          var items=data.RequestResponse;
    //           for(var i=0;i<items.length;i++){
    //             var item=items[i];
    //             state.LineStations.push({LineID:item.LineID,info:item,BackStations:[],WentStations:[],Devices:{Went:[],Back:[]}})
    //           }
    //           store.commit('LineStations_GetByUserID',dat);
              
              
    //         }
    //     })
    //     .catch(function (error) {
    //       var data=error.response.data;
    //       if (data.Error==="Session Failed!"){
    //         Vue.prototype.$session.destroy();
    //         window.open("/#/User/login", "_self");
    //       }
    //     })
    //     .finally(() =>{
    //       state.InlineLoading.BusLine_GetByUserID=false;
    //     });
  },
  LineStations_GetByUserID(state,dat){
    state.InlineLoading.LineStations_GetByUserID=true;
    store.commit('Get',{
      url:Constant.LineStations_GetByUserID
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID),
      loading:'LineStations_GetByUserID',
      response:'LineStations_GetByUserID'
    });
  },
  Trajectory_GetByUserID(state,dat){
    state.Loading.Trajectory_GetByUserID=false;
    store.commit('Get',{
      url:Constant.Trajectory_GetByUserID
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID),
      loading:'Trajectory_GetByUserID',
      response:'Trajectory_GetByUserID'
    });
  },
  MapObject_GetMarkerByFleet(state,dat){
    state.Loading.MapObject_GetMarkerByFleet=true;
    axios
        .get(Constant.MapObject_GetMarkerByFleet.replace('{FleetID}',dat.FleetID)/*, { withCredentials: true }*/)
        .then(response => {
            var data=response.data;
            if(data.Status){
              state.FleetMarkers=data.RequestResponse;
              
            }
        })
        .catch(function (error) {
          var data=error.response.data;
          if (data.Error==="Session Failed!"){
            Vue.prototype.$session.destroy();
            window.open("/#/User/login", "_self");
          }
        })
        .finally(() =>{
          state.Loading.MapObject_GetMarkerByFleet=false;
        });
  },
  GPSData(state,dat){
    state.InlineLoading.GPSData=true;
    store.commit('Get',{
      url:Constant.GPSData
          .replace('{DeviceID}',dat.DeviceID)
          .replace('{TS1}',dat.TS1)
          .replace('{TS2}',dat.TS2),
      loading:'GPSData',
      response:'GPS_DATA'
    });
  },
  Report_X1ByFleet(state,dat){
    state.Loading.Report_X1ByFleet=true;
    store.commit('Get',{
      url:Constant.Report_X1ByFleet
        .replace('{FleetID}',dat.FleetID)
        .replace('{TS1}',dat.TS1)
        .replace('{TS2}',dat.TS2),
      loading:'Report_X1ByFleet',
      response:'FleetReports'
    });
  },
  Report_X1(state,dat){
    state.Loading.Report_X1=true;
    store.commit('Get',{
      url:Constant.Report_X1
      .replace('{VehicleID}',dat.VehicleID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'Report_X1',
      response:'VehicleReports'
    });
  },
  Device_GetByVehicle(state,dat){
    state.Loading.Device_GetByVehicle=true;
    state.Reports=[];
    axios
        .get(Constant.Device_GetByVehicle
          .replace('{DeviceID}',dat.DeviceID)
          .replace('{VehicleID}',dat.VehicleID)
          /*, { withCredentials: true }*/)
        .then(response => {
            var data=response.data;
            if(data.Status){
              state.VehicleReports=data.RequestResponse;
              
            }


        })
        .catch(function (error) {
          var data=error.response.data;
          if (data.Error==="Session Failed!"){
            Vue.prototype.$session.destroy();
            window.open("/#/User/login", "_self");
          }
        })
        .finally(() =>{
          state.Loading.Device_GetByVehicle=false;
        });
  },
  Report_Vehicle_Park(state,dat){
    state.InlineLoading.Report_Vehicle_Park=true;
    store.commit('Get',{
      url:Constant.Report_Vehicle_Park
      .replace('{VehicleID}',dat.VehicleID)
      .replace('{StartTime}',dat.StartTime)
      .replace('{EndTime}',dat.EndTime),
      loading:'Report_Vehicle_Park',
      response:'ParkData'
    });
  },
  Report_Vehicle_Stop(state,dat){
    state.InlineLoading.Report_Vehicle_Stop=true;
    store.commit('Get',{
      url:Constant.Report_Vehicle_Stop
      .replace('{VehicleID}',dat.VehicleID)
      .replace('{StartTime}',dat.StartTime)
      .replace('{EndTime}',dat.EndTime),
      loading:'Report_Vehicle_Park',
      response:'StopData'
    });
  },
  ConnectionState_GetToday(state,dat){
    state.Loading.ConnectionState_GetToday=false;
    store.commit('Get',{
      url:Constant.ConnectionState_GetToday
      .replace('{UserID}',dat.UserID),
      loading:'ConnectionState_GetToday',
      response:'ConnectionState_GetToday'
    });
  },
  ConnectionState_GetMonth(state,dat){
    state.Loading.ConnectionState_GetMonth=false;
    store.commit('Get',{
      url:Constant.ConnectionState_GetMonth
      .replace('{UserID}',dat.UserID),
      loading:'ConnectionState_GetMonth',
      response:'ConnectionState_GetMonth'
    });
  },
  User_GetAllDeviceStatus(state,dat){
    state.Loading.User_GetAllDeviceStatus=false;
    store.commit('Get',{
      url:Constant.User_GetAllDeviceStatus
      .replace('{UserID}',dat.UserID),
      loading:'User_GetAllDeviceStatus',
      response:'User_GetAllDeviceStatus'
    });
  },
  Device_GetAllStatusByUserID2(state,dat){
    state.Loading.User_GetAllDeviceStatus2=false;
    store.commit('Get',{
      url:Constant.Device_GetAllStatusByUserID2
      .replace('{UserID}',dat.UserID),
      loading:'User_GetAllDeviceStatus2',
      response:'User_GetAllDeviceStatus2'
    });
  },
  DeviceDistanceHistory_GetByUserGroupByDay(state,dat){
    state.Loading.DeviceDistanceHistory_GetByUserGroupByDay=false;
    store.commit('Get',{
      url:Constant.DeviceDistanceHistory_GetByUserGroupByDay
      .replace('{UserID}',dat.UserID),
      loading:'DeviceDistanceHistory_GetByUserGroupByDay',
      response:'DeviceDistanceHistory_GetByUserGroupByDay'
    });
  },
  BusLines_GetInfo(state,dat){
    state.Loading.BusLines_GetInfo=false;
    store.commit('Get',{
      url:Constant.BusLines_GetInfo
      .replace('{UserID}',dat.UserID),
      loading:'BusLines_GetInfo',
      response:'BusLines_GetInfo'
    });
  },
  User_GetByGroupID(state,dat){
    state.InlineLoading.User_GetByGroupID=false;
    store.commit('Get',{
      url:Constant.User_GetByGroupID
      .replace('{GroupID}',dat.GroupID),
      loading:'User_GetByGroupID',
      response:'Users'
    });
  },
  AlarmDefinitions_GetAll(state,dat){
    state.Loading.AlarmDefinitions_GetAll=false;
    store.commit('Get',{
      url:Constant.AlarmDefinitions_GetAll,
      loading:'AlarmDefinitions_GetAll',
      response:'AlarmDefinitions'
    });
  },
  DayDefine_GetAll(state,dat){
    state.Loading.DayDefine_GetAll=true;
    store.commit('Get',{
      url:Constant.DayDefine_GetAll,
      loading:'DayDefine_GetAll',
      response:'DayDefine_GetAll'
    });
  },
  SmartTariff_GetAll(state,dat){
    state.Loading.SmartTariff_GetAll=true;
    store.commit('Get',{
      url:Constant.SmartTariff_GetAll
      .replace('{UserID}',1),
      loading:'SmartTariff_GetAll',
      response:'SmartTariff_GetAll'
    });
  },
  SmartTariff_GetByFleetID(state,dat){
    state.InlineLoading.SmartTariff_GetByFleetID=true;
    store.commit('Get',{
      url:Constant.SmartTariff_GetByFleetID
        .replace('{FleetID}',dat.FleetID)
        .replace('{UserID}',1),
      loading:'SmartTariff_GetByFleetID',
      response:'SmartTariff_GetAll'
    });
  },
  SmartTariff_GetToDay(state,dat){
    state.Loading.SmartTariff_GetToDay=true;
    store.commit('Get',{
      url:Constant.SmartTariff_GetToDay
      .replace('{FleetID}',dat.FleetID)
      .replace('{DayDefineID}',dat.DayDefineID),
      loading:'SmartTariff_GetToDay',
      response:'SmartTariff_GetToDay'
    });
  },
  Calendar_GetByDate(state,dat){
    state.Loading.Calendar_GetByDate=true;
    store.commit('Get',{
      url:Constant.Calendar_GetByDate
      .replace('{UserID}',dat.UserID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'Calendar_GetByDate',
      response:'Calendar_GetByDate'
    });
  },
  TrajectoryHistory_GetByUserAndTime(state,dat){
    state.InlineLoading.TrajectoryHistory_GetByUserAndTime=true;
    store.commit('Get',{
      url:Constant.TrajectoryHistory_GetByUserAndTime
      .replace('{UserID}',dat.UserID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'TrajectoryHistory_GetByUserAndTime',
      response:'TrajectoryHistory_GetByUserAndTime'
    });
  },
  TrajectoryHistory_GetByFleetAndTime(state,dat){
    state.InlineLoading.TrajectoryHistory_GetByFleetAndTime=true;
    store.commit('Get',{
      url:Constant.TrajectoryHistory_GetByFleetAndTime
      .replace('{FleetID}',dat.FleetID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'TrajectoryHistory_GetByFleetAndTime',
      response:'TrajectoryHistory_GetByFleetAndTime'
    });
  }, 
  TrajectoryHistory_GetByDeviceIDAndTime(state,dat){
    state.InlineLoading.TrajectoryHistory_GetByDeviceIDAndTime=true;
    store.commit('Get',{
      url:Constant.TrajectoryHistory_GetByDeviceIDAndTime
      .replace('{DeviceID}',dat.DeviceID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'TrajectoryHistory_GetByDeviceIDAndTime',
      response:'TrajectoryHistory_GetByDeviceIDAndTime'
    });
  },
  Trajectory_FleetMustChange(state,dat){
    state.InlineLoading.Trajectory_FleetMustChange=true;
    store.commit('Get',{
      url:Constant.Trajectory_FleetMustChange
      .replace('{UserID}',dat.UserID),
      loading:'Trajectory_FleetMustChange',
      response:'Trajectory_FleetMustChange'
    });
  },
  Trajectory_FleetMustChangeALL(state,dat){
    state.InlineLoading.Trajectory_FleetMustChangeALL=true;
    store.commit('Get',{
      url:Constant.Trajectory_FleetMustChangeALL
      .replace('{UserID}',dat.UserID),
      loading:'Trajectory_FleetMustChangeALL',
      response:'Trajectory_FleetMustChangeALL'
    });
  },
  FleetHistory_GetByDate(state,dat){
    state.InlineLoading.FleetHistory_GetByDate=true;
    store.commit('Get',{
      url:Constant.FleetHistory_GetByDate
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2),
      loading:'FleetHistory_GetByDate',
      response:'FleetHistory_GetByDate'
    });
  },
  FleetHistory_GetByDriver(state,dat){
    state.InlineLoading.FleetHistory_GetByDriver=true;
    store.commit('Get',{
      url:Constant.FleetHistory_GetByDriver
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{DriverID}',dat.DriverID),
      loading:'FleetHistory_GetByDriver',
      response:'FleetHistory_GetByDate'
    });
  },
  FleetHistory_GetByFleet(state,dat){
    state.InlineLoading.FleetHistory_GetByFleet=true;
    store.commit('Get',{
      url:Constant.FleetHistory_GetByFleet
        .replace('{TS1}',dat.TS1)
        .replace('{TS2}',dat.TS2)
        .replace('{FleetID}',dat.FleetID),
      loading:'FleetHistory_GetByFleet',
      response:'FleetHistory_GetByDate'
    });
  },
  FleetHistory_GetByVehicle(state,dat){
    state.InlineLoading.FleetHistory_GetByVehicle=true;
    store.commit('Get',{
      url:Constant.FleetHistory_GetByVehicle
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{VehicleID}',dat.VehicleID),
      loading:'FleetHistory_GetByVehicle',
      response:'FleetHistory_GetByDate'
    });
  },
  DeviceDistanceHistory_GetALLDayByDevice(state,dat){
    state.InlineLoading.DeviceDistanceHistory_GetALLDayByDevice=true;
    store.commit('Get',{
      url:Constant.DeviceDistanceHistory_GetALLDayByDevice
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{DeviceID}',dat.DeviceID),
      loading:'DeviceDistanceHistory_GetALLDayByDevice',
      response:'DeviceDistanceHistory_GetALLDayByDevice'
    });
  },
  DeviceDistanceHistory_GetByUserIDAndDate(state,dat){
    state.InlineLoading.DeviceDistanceHistory_GetByUserIDAndDate=true;
    store.commit('Get',{
      url:Constant.DeviceDistanceHistory_GetByUserIDAndDate
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{UserID}',dat.UserID),
      loading:'DeviceDistanceHistory_GetByUserIDAndDate',
      response:'DeviceDistanceHistory_GetByUserIDAndDate'
    });
  },
  DeviceDistanceHistory_GetByFleetAndDate(state,dat){
    state.InlineLoading.DeviceDistanceHistory_GetByFleetAndDate=true;
    store.commit('Get',{
      url:Constant.DeviceDistanceHistory_GetByFleetAndDate
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID),
      loading:'DeviceDistanceHistory_GetByFleetAndDate',
      response:'DeviceDistanceHistory_GetByFleetAndDate'
    });
  },
  StationTraffic_GetByStasionCodeAndTime(state,dat){
    state.InlineLoading.StationTraffic_GetByStasionCodeAndTime=true;
    store.commit('Get',{
      url:Constant.StationTraffic_GetByStasionCodeAndTime
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{UserID}',dat.UserID)
      .replace('{StationCode}',dat.StationCode),
      loading:'StationTraffic_GetByStasionCodeAndTime',
      response:'StationTraffic_GetByStasionCodeAndTime'
    });
  },
  StationTraffic_GetByDeviceAndTime(state,dat){
    state.InlineLoading.StationTraffic_GetByDeviceAndTime=true;
    store.commit('Get',{
      url:Constant.StationTraffic_GetByDeviceAndTime
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{UserID}',dat.UserID)
      .replace('{DeviceID}',dat.DeviceID),
      loading:'StationTraffic_GetByStasionCodeAndTime',
      response:'StationTraffic_GetByStasionCodeAndTime'
    });
  },
  Station_GetByFleet2(state,dat){
    state.InlineLoading.Station_GetByFleet2=true;
    store.commit('Get',{
      url:Constant.Station_GetByFleet2
      .replace('{FleetID}',dat.FleetID),
      loading:'Station_GetByFleet2',
      response:'Station_GetByFleet2'
    });
  },
  Fleet_GetComplateData(state,dat){
    state.InlineLoading.Fleet_GetComplateData=true;
    store.commit('Get',{
      url:Constant.Fleet_GetComplateData
      .replace('{UserID}',dat.UserID),
      loading:'Fleet_GetComplateData',
      response:'Fleet_GetComplateData'
    });
  },
  Company_GetByUserID(state,dat){
    state.InlineLoading.Company_GetByUserID=true;
    store.commit('Get',{
      url:Constant.Company_GetByUserID
        .replace('{UserID}',dat.UserID),
      loading:'Company_GetByUserID',
      response:'Company_GetByUserID'
    });
  },
  ViolationList_GetAll(state,dat){
    state.InlineLoading.ViolationList_GetAll=true;
    store.commit('Get',{
      url:Constant.ViolationList_GetAll,
      loading:'ViolationList_GetAll',
      response:'ViolationList_GetAll'
    });
  },
  Violation_GetAdvance(state,dat){
    state.InlineLoading.Violation_GetAdvance=true;
    store.commit('Get',{
      url:Constant.Violation_GetAdvance
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.UserID)
      .replace('{DeviceID}',dat.UserID)
      .replace('{TS1}',dat.TS1)
      .replace('{TS2}',dat.TS2)
      .replace('{type}',dat.type),
      loading:'Violation_GetAdvance',
      response:'Violation_GetAdvance'
    });
  },
  Violation_GetTop10ByUserID(state,dat){
    state.InlineLoading.Violation_GetTop10ByUserID=true;
    store.commit('Get',{
      url:Constant.Violation_GetTop10ByUserID
      .replace('{UserID}',dat.UserID),
      loading:'Violation_GetTop10ByUserID',
      response:'Violation_GetTop10ByUserID'
    });
  },
  BusLines_GetByCrop(state,dat){
    state.InlineLoading.BusLines_GetByCrop=true;
    store.commit('Get',{
      url:Constant.BusLines_GetByCrop
      .replace('{UserID}',dat.UserID)
      .replace('{Lat1}',dat.Lat1)
      .replace('{Lat2}',dat.Lat2)
      .replace('{Lng1}',dat.Lng1)
      .replace('{Lng2}',dat.Lng2),
      loading:'BusLines_GetByCrop',
      response:'BusLines_GetByCrop'
    });
  },
  Station_GetByCrop(state,dat){
    state.InlineLoading.Station_GetByCrop=true;
    store.commit('Get',{
      url:Constant.Station_GetByCrop
      .replace('{UserID}',dat.UserID)
      .replace('{Lat1}',dat.Lat1)
      .replace('{Lat2}',dat.Lat2)
      .replace('{Lng1}',dat.Lng1)
      .replace('{Lng2}',dat.Lng2),
      loading:'Station_GetByCrop',
      response:'Station_GetByCrop'
    });
  },
  Device_GetByCrop(state,dat){
    state.InlineLoading.Device_GetByCrop=true;
    store.commit('Get',{
      url:Constant.Device_GetByCrop
      .replace('{UserID}',dat.UserID)
      .replace('{Lat1}',dat.Lat1)
      .replace('{Lat2}',dat.Lat2)
      .replace('{Lng1}',dat.Lng1)
      .replace('{Lng2}',dat.Lng2),
      loading:'Device_GetByCrop',
      response:'Device_GetByCrop'
    });
  },
  SystemInfo_Get(state,dat){
    state.InlineLoading.SystemInfo_Get=true;
    store.commit('Get',{
      url:Constant.SystemInfo_Get,
      loading:'SystemInfo_Get',
      response:'SystemInfo_Get'
    });
  },
  DeviceSipad_GetDetaileByUser(state,dat){
    state.InlineLoading.DeviceSipad_GetDetaileByUser=true;
    store.commit('Get',{
      url:Constant.DeviceSipad_GetDetaileByUser
      .replace("{UserID}",dat.UserID)
      .replace("{TS1}",dat.TS1)
      .replace("{TS2}",dat.TS2),
      loading:'DeviceSipad_GetDetaileByUser',
      response:'DeviceSipad_Data'
    });
    
  },
  DeviceSipad_GetByFleet(state,dat){
    state.InlineLoading.DeviceSipad_GetByFleet=true;
    store.commit('Get',{
      url:Constant.DeviceSipad_GetByFleet
      .replace("{UserID}",dat.UserID)
      .replace("{FleetID}",dat.FleetID)
      .replace("{TS1}",dat.TS1)
      .replace("{TS2}",dat.TS2),
      loading:'DeviceSipad_GetByFleet',
      response:'DeviceSipad_Data'
    });
  },
  DeviceSipad_GetByDevice(state,dat){
    state.InlineLoading.DeviceSipad_GetByDevice=true;
    store.commit('Get',{
      url:Constant.DeviceSipad_GetByDevice
      .replace("{UserID}",dat.UserID)
      .replace("{DeviceID}",dat.DeviceID)
      .replace("{TS1}",dat.TS1)
      .replace("{TS2}",dat.TS2),
      loading:'DeviceSipad_GetByDevice',
      response:'DeviceSipad_Data'
    });
  },
  Rules_GetAll(state,dat){
    state.InlineLoading.Rules_GetAll=true;
    store.commit('Get',{
      url:Constant.Rules_GetAll,
      loading:'Rules_GetAll',
      response:'Rules_GetAll'
    });
  },
  Rules_Get(state,dat){
    state.InlineLoading.Rules_Get=true;
    store.commit('Get',{
      url:Constant.Rules_Get
      .replace("{Roles_ID}",dat.Rules_ID),
      loading:'Rules_Get',
      response:'Rules_Get'
    });
  },
  RulesApiPermissions_GetByRole(state,dat){
    state.InlineLoading.RulesApiPermissions_GetByRole=true;
    store.commit('Get',{
      url:Constant.RulesApiPermissions_GetByRole
      .replace("{RoleID}",dat.RoleID),
      loading:'RulesApiPermissions_GetByRole',
      response:'RulesApiPermissions_GetByRole'
    });
  },
  SipadErrorLog_GetByTurn(state,dat){
    state.InlineLoading.SipadErrorLog_GetByTurn=true;
    store.commit('Get',{
      url:Constant.SipadErrorLog_GetByTurn
      .replace("{UserID}",dat.UserID)
      .replace("{TS1}",dat.TS1)
      .replace("{TS2}",dat.TS2)
      .replace("{TS3}",dat.TS3),
      loading:'SipadErrorLog_GetByTurn',
      response:'SipadErrorLog_GetByTurn'
    });
  },
  DeviceSipad_GetStatus(state,dat){
    state.InlineLoading.DeviceSipad_GetStatus=true;
    store.commit('Get',{
      url:Constant.DeviceSipad_GetStatus
      .replace("{UserID}",dat.UserID)
      .replace("{TS1}",dat.TS1)
      .replace("{TS2}",dat.TS2)
      .replace("{TS3}",dat.TS3),
      loading:'DeviceSipad_GetStatus',
      response:'DeviceSipad_GetStatus'
    });
  },
  User_ActiveList(state,dat){
    state.InlineLoading.User_ActiveList=true;
    store.commit('Get',{
      url:Constant.User_ActiveList
      .replace("{UserID}",dat.UserID)
      .replace("{Count}",dat.Count),
      loading:'User_ActiveList',
      response:'User_ActiveList'
    });
  },
  Fleet_GetAllActiveInfo(state,dat){
    state.InlineLoading.Fleet_GetAllActiveInfo=true;
    store.commit('Get',{
      url:Constant.Fleet_GetAllActiveInfo
      .replace("{UserID}",dat.UserID),
      loading:'Fleet_GetAllActiveInfo',
      response:'Fleet_GetAllActiveInfo'
    });
  },
  Widget1_Get(state,dat){
    state.InlineLoading.Widget1_Get=true;
    store.commit('Get',{
      url:Constant.Widget1_Get,
      loading:'Widget1_Get',
      response:'Widget1_Get'
    });
  },
  Widget2_Get(state,dat){
    state.InlineLoading.Widget2_Get=true;
    store.commit('Get',{
      url:Constant.Widget2_Get,
      loading:'Widget2_Get',
      response:'Widget2_Get'
    });
  },
  Widget3_Get(state,dat){
    state.InlineLoading.Widget3_Get=true;
    store.commit('Get',{
      url:Constant.Widget3_Get,
      loading:'Widget3_Get',
      response:'Widget3_Get'
    });
  },
  Widget4_Get(state,dat){
    state.InlineLoading.Widget4_Get=true;
    store.commit('Get',{
      url:Constant.Widget4_Get,
      loading:'Widget4_Get',
      response:'Widget4_Get'
    });
  },
  Widget5_Get(state,dat){
    state.InlineLoading.Widget5_Get=true;
    store.commit('Get',{
      url:Constant.Widget5_Get,
      loading:'Widget5_Get',
      response:'Widget5_Get'
    });
  },
  //delete
  Authentication_Delete(state,dat){
    state.InlineLoading.Authentication_Delete=false;
    store.commit('Get',{
      url:Constant.Authentication_Delete
      .replace('{UserID}',dat.UserID)
      .replace('{FleetID}',dat.FleetID),
      loading:'Authentication_Delete',
      response:'ResponseAuthentication_Delete'
    });
  },
  DayDefine_DeletByID(state,dat){
    state.InlineLoading.DayDefine_DeletByID=false;
    store.commit('Get',{
      url:Constant.DayDefine_DeletByID
      .replace('{DayDefineID}',dat.DayDefineID),
      loading:'DayDefine_DeletByID',
      response:'DayDefine_DeletByID'
    });
  },
  SmartTariff_Delete(state,dat){
    state.InlineLoading.SmartTariff_Delete=false;
    store.commit('Get',{
      url:Constant.SmartTariff_Delete
      .replace('{DayDefineID}',dat.DayDefineID)
      .replace('{FleetID}',dat.FleetID),
      loading:'SmartTariff_Delete',
      response:'SmartTariff_Delete'
    });
  },
  Violation_Delete(state,dat){
    state.InlineLoading.Violation_Delete=false;
    store.commit('Get',{
      url:Constant.Violation_Delete
      .replace('{UserID}',dat.UserID)
      .replace('{ViolationID}',dat.ViolationID)
      .replace('{ViolationTS}',dat.ViolationTS)
      .replace('{DeviceID}',dat.DeviceID),
      loading:'Violation_Delete',
      response:'Violation_Delete'
    });
  },
  ViolationList_Delete(state,dat){
    state.InlineLoading.ViolationList_Delete=false;
    store.commit('Get',{
      url:Constant.ViolationList_Delete
      .replace('{UserID}',dat.UserID)
      .replace('{ViolationID}',dat.ViolationID),
      loading:'ViolationList_Delete',
      response:'ViolationList_Delete'
    });
  },
  User_Delete(state,dat){
    state.InlineLoading.User_Delete=false;
    store.commit('Get',{
      url:Constant.User_Delete
      .replace('{UserID}',dat.UserID)
      .replace('{UserIDTarget}',dat.UserIDTarget),
      loading:'User_Delete',
      response:'User_Delete'
    });
  },
  UserGroup_DeleteByID(state,dat){
    state.InlineLoading.UserGroup_DeleteByID=false;
    store.commit('Get',{
      url:Constant.UserGroup_DeleteByID
      .replace('{UserID}',dat.UserID)
      .replace('{GroupID}',dat.GroupID),
      loading:'UserGroup_DeleteByID',
      response:'UserGroup_DeleteByID'
    });
  },
  /****************************************************Post*********************** */
  Users_Login(state,data){
    state.Loading.Users_Login=true;
    store.commit('Post',{
      data:data,
      url:Constant.UsersLogin,
      loading:'Users_Login',
      response:'Users_Login'
    });
  },
  Messages_AddAuto(state,data){
    state.Loading.Messages_AddAuto=true;
    store.commit('Post',{
      data:data,
      url:Constant.SendMessage,
      loading:'Messages_AddAuto',
      response:'ResponseMessages_AddAuto'
    });
  },
  Vehicle_Update(state,data){
    state.Loading.Vehicle_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.Vehicle_Update,
      loading:'Vehicle_Update',
      response:'Vehicle_Update'
    });
  },
  Fleet_Update(state,data){
    state.Loading.Fleet_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.Fleet_Update,
      loading:'Fleet_Update',
      response:'ResponseFleet_Update'
    });
  },
  Fleet_Add(state,data){
    state.Loading.Fleet_Add=true;
    store.commit('Post',{
      data:data,
      url:Constant.Fleet_Add,
      loading:'Fleet_Add',
      response:'ResponseFleet_Add'
    });
  },
  RulesPermission_Update(state,data){
    state.Loading.RulesPermission_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.RulesPermission_Update,
      loading:'RulesPermission_Update',
      response:'RulesPermission_Update'
    });
  },
  //DangerousOperations
  Device_MoveToFleet(state,data){
    state.Loading.Device_MoveToFleet=true;
    store.commit('Post',{
      data:data,
      url:Constant.Device_MoveToFleet,
      loading:'Device_MoveToFleet',
      response:'Device_MoveToFleet'
    });
  },
  Driver_Update(state,data){
    state.Loading.Driver_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.Driver_Update,
      loading:'Driver_Update',
      response:'Driver_Update'
    });
  },
  User_Update(state,data){
    store.commit('Post',{
      data:data,
      url:Constant.User_Update,
      loading:'User_Update',
      response:'User_Update'
    });
  },
  Device_AssignToFleet(state,data){
    state.Loading.Device_AssignToFleet=true;
    store.commit('Post',{
      data:data,
      url:Constant.Device_AssignToFleet,
      loading:'Device_AssignToFleet',
      response:'Device_AssignToFleet'
    });
  },
  Authentication_Add(state,data){
    state.InlineLoading.Authentication_Add=true;
    store.commit('Post',{
      data:data,
      url:Constant.Authentication_Add,
      loading:'Authentication_Add',
      response:'ResponseAuthentication_Add'
    });
  },
  Device_Update(state,data){
    state.InlineLoading.Device_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.Device_Update,
      loading:'Device_Update',
      response:'ResponseUpdateDevice'
    });
  },
  User_AddFull(state,data){
    state.InlineLoading.User_AddFull=true;
    store.commit('Post',{
      data:data,
      url:Constant.User_AddFull,
      loading:'User_AddFull',
      response:'ResponseUser_AddFull'
    });
  },
  DayDefine_Insert(state,data){
    state.InlineLoading.DayDefine_Insert=true;
    store.commit('Post',{
      data:data,
      url:Constant.DayDefine_Insert,
      loading:'DayDefine_Insert',
      response:'DayDefine_Insert'
    });
    
  },
  DayDefine_Update(state,data){
    state.InlineLoading.DayDefine_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.DayDefine_Update,
      loading:'DayDefine_Update',
      response:'DayDefine_Update'
    });
  },
  SmartTariff_InsertAndUpdate(state,data){
    state.InlineLoading.SmartTariff_InsertAndUpdate=true;
    store.commit('Post',{
      data:data,
      url:Constant.SmartTariff_InsertAndUpdate,
      loading:'SmartTariff_InsertAndUpdate',
      response:'SmartTariff_InsertAndUpdate'
    });   
  },
  Device_UpdateMaxEN(state,data){
    state.InlineLoading.Device_UpdateMaxEN=true;
    store.commit('Post',{
      data:data,
      url:Constant.Device_UpdateMaxEN,
      loading:'Device_UpdateMaxEN',
      response:'Device_UpdateMaxEN'
    }); 
  },
  Calendar_InsertAndUpdate(state,data){
    state.InlineLoading.Calendar_InsertAndUpdate=true;
    store.commit('Post',{
      data:data,
      url:Constant.Calendar_InsertAndUpdate,
      loading:'Calendar_InsertAndUpdate',
      response:'Calendar_InsertAndUpdate'
    }); 
  },
  Commands_Add(state,data){
    state.InlineLoading.Commands_Add=true;
    store.commit('Post',{
      data:data,
      url:Constant.Commands_Add,
      loading:'Commands_Add',
      response:'Commands_Add'
    });
  },
  Company_Insert(state,data){
    state.InlineLoading.Company_Insert=true;
    store.commit('Post',{
      data:data,
      url:Constant.Company_Insert,
      loading:'Company_Insert',
      response:'Company_Insert'
    });
  },
  Company_UpdateByID(state,data){
    state.InlineLoading.Company_UpdateByID=true;
    store.commit('Post',{
      data:data,
      url:Constant.Company_UpdateByID,
      loading:'Company_UpdateByID',
      response:'Company_UpdateByID'
    });
  },
  ViolationList_Insert(state,data){
    state.InlineLoading.ViolationList_Insert=true;
    store.commit('Post',{
      data:data,
      url:Constant.ViolationList_Insert,
      loading:'ViolationList_Insert',
      response:'ViolationList_Insert'
    });
  },
  Violation_Insert(state,data){
    state.InlineLoading.Violation_Insert=true;
    store.commit('Post',{
      data:data,
      url:Constant.Violation_Insert,
      loading:'Violation_Insert',
      response:'Violation_Insert'
    });
    
  },
  Violation_Update(state,data){
    state.InlineLoading.Violation_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.Violation_Insert,
      loading:'Violation_Update',
      response:'Violation_Update'
    });
  },
  User_ChangePass(state,data){
    state.InlineLoading.User_ChangePass=true;
    store.commit('Post',{
      data:data,
      url:Constant.User_ChangePass,
      loading:'User_ChangePass',
      response:'User_ChangePass'
    });
  },
  RulesApiPermissions_InsertOrUpdate(state,data){
    state.InlineLoading.RulesApiPermissions_InsertOrUpdate=true;
    store.commit('Post',{
      data:data,
      url:Constant.RulesApiPermissions_InsertOrUpdate,
      loading:'RulesApiPermissions_InsertOrUpdate',
      response:'RulesApiPermissions_InsertOrUpdate'
    });
  },
  Rules_Insert(state,data){
    state.InlineLoading.Rules_Insert=true;
    store.commit('Post',{
      data:data,
      url:Constant.Rules_Insert,
      loading:'Rules_Insert',
      response:'Rules_Insert'
    });
  },
  ViolationList_Update(state,data){
    state.InlineLoading.ViolationList_Update=true;
    store.commit('Post',{
      data:data,
      url:Constant.ViolationList_Update,
      loading:'ViolationList_Update',
      response:'ViolationList_Update'
    });
  },
  User_ChangeRole(state,data){
    state.InlineLoading.User_ChangeRole=true;
    store.commit('Post',{
      data:data,
      url:Constant.User_ChangeRole,
      loading:'User_ChangeRole',
      response:'User_ChangeRole'
    });
  },
  Device_AdvancedSearch(state,data){
    state.InlineLoading.Device_AdvancedSearch=true;
    store.commit('Post',{
      data:data,
      url:Constant.Device_AdvancedSearch,
      loading:'Device_AdvancedSearch',
      response:'Devices'
    });
  },
  Vehicle_AdvancedSearch(state,data){
    state.InlineLoading.Vehicle_AdvancedSearch=true;
    store.commit('Post',{
      data:data,
      url:Constant.Vehicle_AdvancedSearch,
      loading:'Vehicle_AdvancedSearch',
      response:'Vehicles'
    });
  },
  Driver_AdvancedSearch(state,data){
    state.InlineLoading.Driver_AdvancedSearch=true;
    store.commit('Post',{
      data:data,
      url:Constant.Driver_AdvancedSearch,
      loading:'Driver_AdvancedSearch',
      response:'Drivers'
    });
  },
  //pay
  TransactionFilter(state,data){
    state.InlineLoading.TransactionFilter=true;
    store.commit('Post',{
      data:data,
      url:Constant.TransactionFilter
      .replace("{page}",data.page)
      .replace("{size}",data.size),
      loading:'TransactionFilter',
      response:'TransactionFilter'
    });
  },
  //Methods
  Post(state,dat){
    let config = {
      headers: {
        Authorization: 'Bearer '+localStorage.getItem('token'),
      },
    }
    state[dat.response]={
      RequestResponse:[],
      Data_1:[],
      Data_2:[],
      Data_3:[],
      Data_1:[],
    };
    axios
        .post(dat.url,dat.data,config)
        .then(response => {
  
            var data=response.data;
            state[dat.response]=data;
        })
        .catch(function (error) {
          if(error.response.status===403){
            Vue.prototype.$session.destroy();
            window.open("/#/User/login", "_self");
          }
          else if(error.response.status===404){
            store.commit('ShowToast',{type:'error',message:'درخواست نامعتبر'})
          }
        })
        .finally(() =>{
          state.Loading[dat.loading]=false;
          state.InlineLoading[dat.loading]=false;

        });
  },
  Get(state,dat){
    let config = {
      headers: {
        Authorization: 'Bearer '+localStorage.getItem('token'),
      },
    }
    state[dat.response]={
      RequestResponse:[],
      Data_1:[],
      Data_2:[],
      Data_3:[],
      Data_4:[],
    };
    axios
        .get(dat.url,config)
        .then(response => {
            var data=response.data;
            state[dat.response]=data;
        })
        .catch(function (error) {
          if(error.response.status===403){
            Vue.prototype.$session.destroy();
            window.open("/#/User/login", "_self");
          }
          else if(error.response.status===404){
            store.commit('ShowToast',{type:'error',message:'درخواست نامعتبر'})
          }
        })
        .finally(() =>{
          state.Loading[dat.loading]=false;
          state.InlineLoading[dat.loading]=false;
        });
  },
}

const store =new Vuex.Store({
  state,
  mutations,
  getters: {
    // GPS_DATA(state){
    //   return state.state.GPS_DATA;
    // }
    
  },
  actions: {
   
  }
})

export default store;